import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { IUserSetingsResponse } from "../../test/interfaces/user-settings-response.interface"
import { environment } from "../../../../environments/environment"
import { RMBTTermsV6, TERMS_VERSION, UUID } from "../../test/constants/strings"
import { tap } from "rxjs"
import { NO_ERROR_HANDLING } from "../constants/strings"
import Cookies from "js-cookie"

@Injectable({
  providedIn: "root",
})
export class SettingsService {
  constructor(private readonly http: HttpClient) {}

  getSettings() {
    let uuid = localStorage.getItem(UUID) || Cookies.get(UUID) || undefined
    if (uuid && !this.isValidUuid(uuid)) {
      localStorage.removeItem(UUID)
      Cookies.remove(UUID)
      uuid = undefined
    }
    let tcVersion = localStorage.getItem(TERMS_VERSION) || undefined
    if (!tcVersion && Cookies.get(RMBTTermsV6)) {
      tcVersion = "6"
      localStorage.setItem(TERMS_VERSION, tcVersion)
    }
    return this.http
      .post<IUserSetingsResponse>(
        `${environment.api.baseUrl}/RMBTControlServer/settings`,
        {
          language: "en",
          name: "RTR-Netztest",
          terms_and_conditions_accepted: !!tcVersion,
          type: "DESKTOP",
          version_code: "1",
          version_name: "0.1",
          ...(uuid ? { uuid } : {}),
          ...(tcVersion
          ? { terms_and_conditions_accepted_version: parseInt(tcVersion) }
            : {}),
        },
        {
          headers: {
            [NO_ERROR_HANDLING]: "true",
          },
        }
      )
      .pipe(
        tap((settings) => {
          uuid = settings?.settings[0]?.uuid
          if (uuid) {
          localStorage.setItem(UUID, uuid)
          Cookies.set(UUID, uuid, {
            expires: 365,
            sameSite: "lax",
            secure: globalThis.location?.protocol === "https:",
          })
          }
          // In development, rewrite backend-provided URLs that point directly at
          // internal hosts so they route through the local proxy instead, avoiding
          // CORS blocks in the browser.
          const urls = settings?.settings?.[0]?.urls
          if (urls && environment.api.baseUrl.startsWith("http://localhost")) {
            const proxyBase = environment.api.baseUrl
            const rewrite = (url: string | undefined) => {
              if (!url) return url
              try {
                const parsed = new URL(url)
                // Only rewrite if the URL is NOT already pointing at the proxy
                if (parsed.origin !== proxyBase) {
                  return `${proxyBase}${parsed.pathname}`
                }
              } catch {
                // not a valid absolute URL, leave as-is
              }
              return url
            }
            urls.url_map_server = rewrite(urls.url_map_server)!
            urls.url_statistic_server = rewrite(urls.url_statistic_server)!
            urls.url_web_statistic_server = rewrite(urls.url_web_statistic_server)!
            urls.url_web_recent_server = rewrite(urls.url_web_recent_server)!
          }
        })
      )
  }

  private isValidUuid(value: string): boolean {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      value,
    )
  }
}
